import { motion } from "framer-motion";
import { Award, Zap, Wallet, PenTool, Cpu, Users } from "lucide-react";

const FEATURES = [
  { icon: Award, title: "Premium Print Quality", desc: "Calibrated colour, sharp detail, and finishes that feel as good as they look." },
  { icon: Zap, title: "Fast Delivery", desc: "Most projects ready in 24–48 hours without compromising quality." },
  { icon: Wallet, title: "Affordable Pricing", desc: "Transparent quotes with bulk-friendly rates for businesses." },
  { icon: PenTool, title: "Custom Design Support", desc: "In-house designers help you craft files that print beautifully." },
  { icon: Cpu, title: "Modern Technology", desc: "Latest offset, digital and large-format machinery." },
  { icon: Users, title: "Experienced Team", desc: "A decade of experience handling brands of every scale." },
];

export default function WhyChooseUs() {
  return (
    <section id="why-us" className="py-24 bg-brand-ink text-white relative overflow-hidden">
      <div className="absolute -top-40 -right-32 h-[500px] w-[500px] rounded-full bg-brand-blue/30 blur-3xl" />
      <div className="absolute -bottom-40 -left-32 h-[460px] w-[460px] rounded-full bg-brand-green/20 blur-3xl" />

      <div className="container-x relative">
        <div className="max-w-2xl">
          <div className="overline text-brand-green">Why PPrints</div>
          <h2 className="mt-3 font-display text-4xl sm:text-5xl font-extrabold leading-tight tracking-tight">
            Trusted print partners — <span className="text-brand-green">because every detail matters.</span>
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {FEATURES.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              data-testid={`why-feature-${i}`}
              className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur p-6 hover:bg-white/10 hover:-translate-y-1 transition-all"
            >
              <div className="h-12 w-12 grid place-items-center rounded-xl bg-brand-green/15 text-brand-green">
                <f.icon className="h-5 w-5" />
              </div>
              <h3 className="mt-5 font-display font-bold text-lg">{f.title}</h3>
              <p className="mt-2 text-sm text-white/70 leading-relaxed">{f.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
